var map = {
	"./": 84,
	"./algorithm-visualizer/README.md": 211,
	"./index": 84,
	"./index.js": 84,
	"./scratch-paper/README.md": 212,
	"./skeletons/code": 112,
	"./skeletons/code.cpp": 213,
	"./skeletons/code.java": 214,
	"./skeletons/code.js": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;